import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Video } from 'lucide-react';

const HandbookHubTabs: React.FC = () => {
  const location = useLocation();
  const onTraining = location.pathname.startsWith('/people/handbook/training');

  return (
    <nav className="people-handbook-hub-tabs" aria-label="Handbook sections">
      <Link
        to="/people/handbook"
        className={`people-handbook-hub-tab ${!onTraining ? 'active' : ''}`}
      >
        <BookOpen size={16} aria-hidden />
        Policies
      </Link>
      <Link
        to="/people/handbook/training"
        className={`people-handbook-hub-tab ${onTraining ? 'active' : ''}`}
      >
        <Video size={16} aria-hidden />
        Training videos
      </Link>
    </nav>
  );
};

export default HandbookHubTabs;
